import { Navigate, useLocation } from 'react-router-dom';

/**
 * LegacyPathRedirect
 * ----------------------------------------------------------------------------
 * Atomic 301-equivalent redirect for restructured Study Abroad URLs.
 *
 * Maps EXACTLY one legacy path to its canonical destination. Query parameters
 * present on the source URL (e.g. ?utm_source=…) are preserved and appended
 * to the destination. The hash fragment is also forwarded.
 *
 * This is a client-side redirect — sufficient for funnel attribution and link
 * sharing. For a TRUE HTTP 301 (recommended for SEO), apply the equivalent
 * rule at the ingress / CDN layer (see /app/memory/redirects.md).
 *
 * Frozen mappings (do NOT expand without product approval):
 *   /study-abroad/visa/germany/student-visa-guide/  →  /study-abroad/germany/student-visa/
 */
const REDIRECT_MAP = Object.freeze({
  '/study-abroad/visa/germany/student-visa-guide': '/study-abroad/germany/student-visa',
});

const LegacyPathRedirect = ({ to }) => {
  const location = useLocation();
  // `to` may be passed explicitly (preferred) or resolved from the frozen map.
  const destination =
    to || REDIRECT_MAP[location.pathname.replace(/\/+$/, '')] || '/';

  // Guard: never redirect to the same path (prevents infinite loops).
  if (destination === location.pathname || destination === location.pathname.replace(/\/+$/, '')) {
    return null;
  }

  return (
    <Navigate
      to={{
        pathname: destination,
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  );
};

export default LegacyPathRedirect;
